import { Component, Vue, Watch } from 'vue-property-decorator';

import { DataLoad } from '@/Utils/decorator/data-load';
import MessageBus from '@/Utils/message/message-bus';
import { NavigationInformationItem } from '@/component/NavigationInformation/menu-item/navigation-information';
import ParamCardList from './param-card-list';
import api_data from '@/Api/api_data';
import paramsMapList from './params-map-list';

/**
 *
 */
interface Type {
    /**
     *
     */
    type: string;
    /**
     *
     */
    params: string;
}
/**
 * @author guan
 * @description 基础加载数据父类
 */
@Component({
    components: {},
})
export default class BaseLoad<T> extends Vue {
    /** 有导航的情况下由子类复写 */
    Message: NavigationInformationItem[] = [];
    /** 加载状态 */
    spinningStatus = true;
    /** 顶部标题 */
    title = '测试';
    /** 当前数据类型,暂时添加type,特殊需求请自行添加 */
    dataType = {} as Type;
    /** 颜色列表 */
    readonly colorList = ['#46edcf', '#9a81ff', '#5983fb', '#ffa14a', '#3ad8db', '#fba38d', '#00bdf4', '#fc8819', '#2860fd', '#9556ff', '#2abbfe', '#ffc849'];
    /**
     * @author guan
     * @description 获取路径信息
     * @return void
     */
    async LoadType(): Promise<void> {
        this.dataType = await this.$route.meta?.params;
    }
    /** 获取到的数据 */
    cardMessage = {} as T;
    /** paramsMapList */
    paramsMapList = {};
    /**
     * @author guan
     * @description 加载对应的映射信息
     * @param type 当前页面获取数据type
     * @return void
     */
    loadParamsMapMessage(type: string): void {
        this.paramsMapList = paramsMapList[type];
        this.title = this.dataType.params;
    }

    /**
     * 获得getTaskId
     */
    get taskId(): number {
        return this.$store.getters.getCurrentPlanId || 0;
    }

    /**
     *获取当前planId
     */
    get currentPlanId(): number {
        return this.$store.getters.getCurrentPlanId;
    }
    /**
     *单次获取结果
     */
    @Watch('currentPlanId')
    @DataLoad()
    async loadData(): Promise<void> {
        /** 加载效果，自行使用 */
        this.spinningStatus = true;
        try {
            const data = (await api_data.getEvaluationDataByParams({ ...this.dataType, id: this.taskId })).results[0] as T;
            this.spinningStatus = false;
            this.$nextTick(() => {
                if (data) {
                    this.cardMessage = data;
                } else {
                    this.cardMessage = ParamCardList[this.dataType.type];
                }
            });
        } catch (e) {
            this.cardMessage = {} as T;
            this.spinningStatus = false;
            MessageBus.Notification('error', { description: `${e}`, message: '提示' });
            throw new Error(`未知错误,${e}`);
        }
    }
    /**
     * @author guan
     * @description 值处理请在此处
     * @return void
     * @param item 消息内容
     */
    paramsDeal(): string {
        return '';
    }
    /**
     * @author guan
     * @description 开局加载数据
     * @return void
     */
    mounted(): void {
        this.LoadType.apply(this, [])
            .then(() => {
                this.loadParamsMapMessage(this.dataType.type);
                this.loadData().catch((e) => e);
            })
            .catch((e) => e);
    }
    /**
     * @author guan
     * @description 保存参数,请重写此方法
     * @return void
     */
    async saveData(): Promise<void> {
        try {
            const data = this.cardMessage as T & { id: string | number | undefined };
            if (data.id == null) {
                await api_data.postEvaluationDataByParams({
                    ...this.cardMessage,
                    type: this.dataType.type,
                    simu: this.$route.query.simu_id as string,
                    planId: this.$store.getters.getCurrentPlanId,
                });
                await this.loadData();
            } else {
                await api_data.patchEvaluationDataByParams({ ...this.cardMessage, type: this.dataType.type });
            }
        } catch (e) {
            MessageBus.Notification('error', { description: '保存失败', message: '提示' });
            throw new Error(`保存失败，未知错误,${e}`);
        }
    }
}
